import { privacyPolicyUrl } from "@saleor/privacyPolicy/urls";
import PrivacyPolicy from "@saleor/privacyPolicy/views";
import { parse as parseQs } from "qs";
import React, { useContext } from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";

import Layout from "./components/Layout";
import { UserContext as Context } from "./types";
import {
  changePasswordPath,
  LoginUrlQueryParams,
  newPasswordPath,
  passwordResetInvalidPath,
  passwordResetPath,
  passwordResetSuccessPath,
  updateEmailPath
} from "./urls";
import ChangePassword from "./views/ChangePassword";
import LoginViewComponent from "./views/Login";
import NewPassword from "./views/NewPassword";
import ResetPassword from "./views/ResetPassword";
import ResetPasswordInvalid from "./views/ResetPasswordInvalid";
import ResetPasswordSuccess from "./views/ResetPasswordSuccess";
import UpdateEmailView from "./views/UpdateEmail";

const LoginView: React.FC<RouteComponentProps<any>> = () => {
  const qs = parseQs(location.search.substr(1));
  const params: LoginUrlQueryParams = qs;

  return <LoginViewComponent params={params} />;
};

export const UserContext = React.createContext<Context>({
  loginByToken: undefined,
  login: undefined,
  loginByExternalPlugin: undefined,
  logout: undefined,
  requestLoginByExternalPlugin: undefined,
  authenticating: false,
  authenticated: false,
  zone: undefined,
  setZone: undefined,
  listCompany: undefined,
  soldToId: undefined,
  tokenRefresh: undefined,
  tokenRefreshApp: undefined
});

const AuthRouter: React.FC = () => (
  <Layout>
    <Switch>
      <Route path={passwordResetSuccessPath} component={ResetPasswordSuccess} />
      <Route path={passwordResetInvalidPath} component={ResetPasswordInvalid} />
      <Route path={passwordResetPath} component={ResetPassword} />
      <Route path={newPasswordPath} component={NewPassword} />
      <Route path={changePasswordPath} component={ChangePassword} />
      <Route path={updateEmailPath} component={UpdateEmailView} />
      <Route exact path={privacyPolicyUrl} component={PrivacyPolicy} />
      <Route component={LoginView} />
    </Switch>
  </Layout>
);

AuthRouter.displayName = "AuthRouter";
export default AuthRouter;

export * from "./utils";
export const useUser = () => useContext(UserContext);
